// import axios from 'axios'
let url = 'AutoAtendimentoConfiguracao/'
import http from './http'
// require('@/service/service_autoatendimento/httpsemtoken')
// var urlAdaptor = ''
// var http = axios.create({
//   baseURL: urlAdaptor
// })
export function getConfiguracao() {
  return http.get(url)
}
export function getLogo() {
  return http.get(`${url}Logo`, false)
}
export function getLogoAdaptor() {
  return http.get(`${url}Logo`, false)
}